import diagram from './diagram';
import diagramEditingModel from './diagramEditingModel';
import findings from './findings';
import followUpDetail from './followUpDetail';
import SelectProblems from './selectProblems';
import linkStudies from './linkStudies';
import otherStudyDetails from './otherStudyDetails';
import patient from './patient';
import patientDetails from './patientDetails';
import patientsList from './patientsList';
import studyDetails from './studyDetails';
import survey from './survey';
import worklist from './worklist';
import WorklistFilterViewModel from './WorklistFilterViewModel';
import PrinterDocumentViewModel from './PrinterDocumentViewModel';
import SelectUltrasoundTechniqueModel from './selectUltrasoundTechnique';
import DocumentCreateDialogModel from './documentCreateDialogModel';
import ContactDocumentCreateDialogModel from './ContactDocumentCreateDialogModel';
import patientReferringPhysiciansDialogModel from './patientReferringPhysiciansDialogModel';
import addReferringPhysicianDialogModel from './addReferringPhysicianDialogModel';
import FollowUpResolveDialogModel from './followUpResolveDialogModel';
import MultiRadioDetailsDialogModel from './multiRadioDetailsDialogModel';

import {module} from "../app"

import {ImplantsRecordDetailDialogModel} from "./implantsRecordDetails";
import {RightHistoryRecordDetailDialogModel} from "./rightHistoryRecordDetail";
import { PatientImportDocumentDialogModel } from './patientImportDocumentDialogModel';

import {ClipBoardDetailDialogModel} from './clipboardDetail';
import {ClipBoardNoteDetailDialogModel} from "./clipboardNoteDetail";



module.factory('RightHistoryRecordDetailDialogModel', () => RightHistoryRecordDetailDialogModel);
module.factory('ClipBoardDetailDialogModel', () => ClipBoardDetailDialogModel);
module.factory('ClipBoardNoteDetailDialogModel', () => ClipBoardNoteDetailDialogModel);
module.factory('ImplantsRecordDetailDialogModel', () => ImplantsRecordDetailDialogModel);
module.factory('PatientImportDocumentDialogModel', () => PatientImportDocumentDialogModel);



// WEBPACK FOOTER //
// ./src/scripts/models/index.js